module.exports = __webpack_public_path__ + "img/p45.a286f562.png";